import React from "react"
import { IngestionJob } from "../../api/ingestionJob"
import { AddInvoicesStep } from "./add-invoices-step"
import { ConfirmInvoicesDataStep } from "./confirm-invoices-data-step"
import { InblockedInvoicesDataStep } from "./inblocked-invoices-data-step"

export const InvoicesWorkflow = ({ isEdit, isAssetsModification, workflowStep, job, next, back, cancel, startOver, $refreshEvents }:
  { isEdit: boolean, isAssetsModification: any, workflowStep: number, job: IngestionJob, next, back, cancel, startOver, $refreshEvents }) => {

  const isAddInvoicesStepEnabled = () => {
    if (isEdit) return false;

    return workflowStep === 1;
  }

  const isConfirmInvoicesDataStepEnabled = () => {
    if (isEdit && workflowStep == 0) return true;

    return workflowStep === 2;
  }

  const isInblockedInvoicesDataStepEnabled = () => {
    if (isEdit && workflowStep == 1) return true;

    return workflowStep === 3;
  }

  return <>
    {isAddInvoicesStepEnabled() && <AddInvoicesStep job={job} next={next} back={back} cancel={cancel} />}
    {isConfirmInvoicesDataStepEnabled() && <ConfirmInvoicesDataStep isEdit={isEdit} isAssetsModification={isAssetsModification} job={job} next={next} cancel={cancel} startOver={startOver} $refreshEvents={$refreshEvents} />}
    {isInblockedInvoicesDataStepEnabled() && <InblockedInvoicesDataStep job={job} back={back} $refreshEvents={$refreshEvents} />}
  </>
}
